//=================================================================================================
// SCRIPTING
//=================================================================================================

<script>
import Vue       from 'vue';
import Component from 'vue-class-component';
import NotFound  from '@/views/NotFound';

@Component({
	components : {
		NotFound,
	},
})
export default class Players extends Vue {}
</script>

//=================================================================================================
// TEMPLATING
//=================================================================================================

<template>
<NotFound>Under Construction</NotFound>
</template>
